"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getIrtEstimates = getIrtEstimates;
exports.getTrialIrtEstimates = getTrialIrtEstimates;
exports.getItemParameters = getItemParameters;
const clowderSetup_1 = require("./clowderSetup");
function getIrtEstimates(thetas, thetaSEs, scaleTheta, catsScaled) {
    const irtEstimates = catsScaled.reduce((acc, cat) => {
        const { thetaEstimate, thetaSE } = scaleTheta(thetas[cat], thetaSEs[cat], cat);
        acc[cat] = {
            thetaEstimate,
            thetaEstimateRaw: thetas[cat],
            thetaSE,
            thetaSERaw: (0, clowderSetup_1.clampPositive)(thetaSEs[cat]),
        };
        return acc;
    }, {});
    return irtEstimates;
}
function getTrialIrtEstimates(trialData) {
    const thetas = {};
    const thetaSEs = {};
    Object.keys(trialData).forEach((key) => {
        thetas[key] = trialData[key].thetaEstimate;
        thetaSEs[key] = trialData[key].thetaSE;
    });
    return { thetas, thetaSEs };
}
function getItemParameters(stimulus) {
    return stimulus.zetas.reduce((acc, item) => {
        acc[item.cats[0]] = item.zeta;
        return acc;
    }, {});
}
